import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type GetAccountsForRoutingQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['NonNegativeInt']['input']>;
  signup?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type GetAccountsForRoutingQuery = { __typename?: 'Query', me?: { __typename?: 'AuthenticatedUser', id: string, accounts: { __typename?: 'UserAccountDataConnection', nodes: Array<{ __typename?: 'UserAccountData', account: { __typename?: 'Account', id: string, managedBy?: Types.AccountManagementTypes | null, version?: number | null, owner?: { __typename?: 'Owner', id: string } | null } }> }, inboxAccounts?: { __typename?: 'InboxAccountConnection', nodes: Array<{ __typename?: 'InboxAccount', id?: string | null, version?: number | null }> } | null } | { __typename?: 'IdentifiedUser', id: string } | null };


export const GetAccountsForRouting = /*#__PURE__*/ gql`
    query GetAccountsForRouting($first: NonNegativeInt = 500, $signup: Boolean) {
  me {
    id
    ... on AuthenticatedUser {
      accounts(
        page: {first: $first}
        order: {direction: ASC, field: DISPLAY_NAME}
        signup: $signup
      ) {
        nodes {
          account {
            id
            managedBy
            version
            owner {
              id
            }
          }
        }
      }
      inboxAccounts(page: {first: $first}) {
        nodes {
          id
          version
        }
      }
    }
  }
}
    ` as unknown as DocumentNode<GetAccountsForRoutingQuery, GetAccountsForRoutingQueryVariables>;

          

          export const useGetAccountsForRoutingQuery = (options?:QueryHookOptions<GetAccountsForRoutingQuery, GetAccountsForRoutingQueryVariables>) => useQuery(GetAccountsForRouting, options);

          

          export type GetAccountsForRoutingQueryOptions = QueryHookOptions<GetAccountsForRoutingQuery, GetAccountsForRoutingQueryVariables>;

          

          export const useGetAccountsForRoutingLazyQuery = (options?:LazyQueryHookOptions<GetAccountsForRoutingQuery, GetAccountsForRoutingQueryVariables>) => useLazyQuery(GetAccountsForRouting, options);

          

          export type GetAccountsForRoutingQueryResult = ReturnType<typeof useGetAccountsForRoutingQuery>;

          
